var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoUtv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 120,
    viewBox: "0 0 317 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.405 0.0748698L277.412 100.619C274.882 107.132 268.631 111.475 261.637 111.475C254.716 111.475 248.465 107.207 245.935 100.769L205.901 0.0748698C205.901 0.0748698 218.254 0.0748698 227.481 0.0748698C233.508 0.0748698 238.941 3.81813 241.099 9.5079C248.019 27.8499 262.678 66.5553 262.678 66.5553L286.714 0L316.405 0.0748698Z",
    fill: "url(#paint0_linear_8_123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.906 0.0748596L210.217 28.374H175.689V111.475H145.775V28.374H106.411V0.0748596H198.906Z",
    fill: "url(#paint1_linear_8_123)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.532 0.0748596H70.5437C70.5437 0.0748596 70.5437 14.1495 70.5437 65.058C70.5437 77.2611 60.4979 85.4214 50.2289 85.4214C36.1648 85.4214 29.9885 73.5178 29.9885 65.058C29.9885 39.9781 29.9885 24.5558 29.9885 15.1228C29.9885 6.81274 23.2913 0.0748596 15.0315 0.0748596C7.51573 0.0748596 0 0.0748596 0 0.0748596V55.6998C0 94.3304 18.2312 113.72 52.0148 113.72C80.143 113.72 100.532 97.325 100.532 56.9725V0.0748596Z",
    fill: "url(#paint2_linear_8_123)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_123",
    x1: 261.153,
    y1: 0,
    x2: 261.153,
    y2: 111.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9B32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_123",
    x1: 158.314,
    y1: 0.0748596,
    x2: 158.314,
    y2: 111.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9B32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_123",
    x1: 50.2661,
    y1: 0.0748596,
    x2: 50.2661,
    y2: 113.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9B32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUtv);
export default __webpack_public_path__ + "static/media/logoUTV.ea4547cc0a1f184ab5fd69c3f071b803.svg";
export { ForwardRef as ReactComponent };